export const DocumentType = () => {
  return <div>Document Type</div>;
};
